var PersonType;
(function (PersonType) {
    PersonType["Traveler"] = "traveler";
    PersonType["Agent"] = "agent";
    PersonType["TeamMember"] = "teamMember";
})(PersonType || (PersonType = {}));
export default PersonType;
